<template>
  <el-dialog title="延期离店"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-card shadow="none">
      <el-col :span="24">
        <el-form :model="delayData"
                 :rules="checkDelay"
                 ref="delayForm"
                 label-width="125px"
                 class="delay-form">

          <el-row :gutter="10">
            <el-form-item label="离店时间:"
                          prop="exp_date">
              <el-col>
                <el-date-picker v-model="delayData.exp_date"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>

              </el-col>
              <el-col>
                <el-time-select v-model="delayData.exp_time"
                                :picker-options="{
                            start: '00:00',
                            step: '01:00',
                            end: '23:00'
                          }">
                </el-time-select>
              </el-col>
            </el-form-item>
          </el-row>

        </el-form>
      </el-col>
    </el-card>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary"
                 @click="handleConfirm('delayForm')">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {}
  },
  data() {
    return {
      showModal: this.isShow,
      delayData: {
        id: '',
        exp_date: '',
        exp_time: '',
        in_date: '',
        in_time: ''
      },
      checkDelay: {
        exp_date: [{ required: true, message: '请选择离店日期时间' }]
      }
    }
  },
  created() {
    this.delayData = this.data
  },
  methods: {
    getInfo() {
      return 'm'
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.delayData.exp_date < this.delayData.in_date) {
            this.$message.error('离店日期不能小于入住日期')
            return false
          } else if (this.delayData.exp_date == this.delayData.in_date) {
            if (this.delayData.exp_time <= this.delayData.in_time) {
              this.$message.error('离店时间不能小于或等于入住时间')
              return false
            }
          }

          fetch.hotelDelay({ ...this.delayData }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.handleCancel('refresh')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel(val) {
      this.$emit('handleClose', val)
    }
  }
}
</script>

<style></style>
